import React from "react";
import MiniAreaChart from "./MiniAreaChart";
import { MetricTrendCardData } from "../../types";

interface MetricTrendCardProps {
  data: MetricTrendCardData;
  isStaticDisabled?: boolean;
}

const MetricTrendCard: React.FC<MetricTrendCardProps> = ({
  data,
  isStaticDisabled = false,
}) => {
  return (
    <div
      className={`metric-trend-card${
        isStaticDisabled ? " metric-trend-card--static-disabled" : ""
      }`}
    >
      <div className="metric-trend-card__header">
        <span className="metric-trend-card__label">{data.label}</span>
        <span
          className={`metric-trend-card__badge metric-trend-card__badge--${data.badgeVariant}`}
        >
          ↗ {data.badge}
        </span>
      </div>
      <div className="metric-trend-card__value">{data.value}</div>
      <MiniAreaChart data={data.chartPoints} color={data.chartColor} chartId={data.id} />
    </div>
  );
};

export default MetricTrendCard;
